import React from 'react';
import { ScrollWrapper, Table } from '../components/Table';
import { Row } from 'features/monitoring/students/Row';
import { parallels, StudentsTableProps } from 'features/monitoring/models';

interface Props extends StudentsTableProps {
  showSchools: boolean;
}

const Component = ({ rows, total, showSchools }: Props) => {
  return (
    <ScrollWrapper>
      <Table>
        <thead>
          <tr>
            <th rowSpan={2} style={{ paddingLeft: '16px', width: '195px', textAlign: 'start' }}>
              {showSchools ? 'Населённый пункт' : 'Муниципалитет'}
            </th>
            {showSchools && (
              <th rowSpan={2} style={{ paddingLeft: '16px', width: '161px', textAlign: 'start' }}>
                Школа
              </th>
            )}
            <th colSpan={8} style={{ width: '525px' }}>
              Количество учеников по параллелям, прошедших тестирование
            </th>
          </tr>
          <tr>
            <th>2</th>
            <th>3</th>
            <th>4</th>
            <th>5</th>
            <th>6</th>
            <th>7</th>
            <th>8</th>
            <th>9</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <Row {...row} showSchool={showSchools} />
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={showSchools ? 2 : 1} style={{ paddingLeft: '16px', textAlign: 'start' }}>
              Итого по {showSchools ? 'муниципалитету' : 'региону'}:
            </td>
            {parallels.map((parallel) => (
              <td>{total[parallel] || 0}</td>
            ))}
          </tr>
        </tfoot>
      </Table>
    </ScrollWrapper>
  );
};

export default Component;
